import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import './holiday.css'
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import FetchApi from '../../../fetch-api/fetch-api';
import { Stack } from '@mui/system';
import AgGridContainer from '../../../componant/gridContainer/gridContainer';


const UserHoliday = () => {
  const fetchApi = FetchApi()
  const [rowData, setRowData] = useState([])
  const state = useSelector((state: any) => state.allEmployee)

  useEffect(() => {
    if (state.holiday.length > 0) {
      setRowData(state.holiday)
      console.log(state.holiday, "Holiday")
    }
  }, [state])
  useEffect(() => {
    fetchApi.fetchHoliday()
  }, [])
  const [columnDefs]: any[] = useState([
    {
      headerName: "S.No",
      field: "sno",
      minWidth: 100,
      flex: 1,
      resizable: true,
      filter: true,
      cellStyle: () => ({
        alignItems: "center",

      })
    },
    {
      headerName: "Date",
      field: "date",
      minWidth: 416,
      flex: 1,
      resizable: true,
      filter: true,
      cellStyle: () => ({
        alignItems: "center",

      })
    },
    {
      headerName: "Reasons",
      field: "reason",
      minWidth: 416,
      flex: 1,
      resizable: true,
      filter: true,
      headerClass: 'text-center',
      cellStyle: () => ({
        alignItems: "center",
      }),

    }
  ])

  return (
    <div className='main'>
      <div className='main-container' >
        <div className='heading heading-start-center height-40'>
          <h2>Holiday</h2>
        </div>
        <div className='cal-40'>
          <div className='holiday-list-container'>
            <div className="table-wrapper">

              <AgGridContainer rowData={rowData} columnDefs={columnDefs} />
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default UserHoliday